(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    (function () {
  function initCountdownTimer(timer) {
    var existingInterval = parseInt(timer.dataset.ctInterval);
    if (existingInterval) clearInterval(existingInterval);

    var endDay = parseInt(timer.dataset.endDay);
    var endMonth = parseInt(timer.dataset.endMonth);
    var endYear = parseInt(timer.dataset.endYear);
    var endHour = parseInt(timer.dataset.endHour || '0');
    var endMinute = parseInt(timer.dataset.endMinute || '0');

    if (!endDay || !endMonth || !endYear) {
      timer.setAttribute('hidden', '');
      return;
    }

    var end = new Date(endYear, endMonth - 1, endDay, endHour, endMinute, 0);

    var startDay = parseInt(timer.dataset.startDay);
    var startMonth = parseInt(timer.dataset.startMonth);
    var startYear = parseInt(timer.dataset.startYear);
    var startHour = parseInt(timer.dataset.startHour || '0');
    var startMinute = parseInt(timer.dataset.startMinute || '0');

    var start = (startDay && startMonth && startYear)
      ? new Date(startYear, startMonth - 1, startDay, startHour, startMinute, 0)
      : null;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var now = new Date();
      if (start && now < start) {
        timer.setAttribute('hidden', '');
        return;
      }
      var diff = end - now;
      if (diff <= 0) {
        timer.setAttribute('hidden', '');
        clearInterval(parseInt(timer.dataset.ctInterval));
        return;
      }
      timer.removeAttribute('hidden');
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);
      var daysEl = timer.querySelector('[data-ct-days]');
      var hoursEl = timer.querySelector('[data-ct-hours]');
      var minsEl = timer.querySelector('[data-ct-minutes]');
      var secsEl = timer.querySelector('[data-ct-seconds]');
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(minutes);
      if (secsEl) secsEl.textContent = pad(seconds);
    }

    tick();
    var intervalId = setInterval(tick, 1000);
    timer.dataset.ctInterval = intervalId;
  }

  function initAllInContext(root) {
    root.querySelectorAll('.countdown-timer').forEach(initCountdownTimer);
  }

  initAllInContext(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAllInContext(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
